  // Market Title, Description, SGP INFO, Collapsed or not
export const useAccessibility = ({ title, description, hasSGP, isOpen }) => {
    const ariaLabelArray = [title, description, hasSGP ? "SGP" : null ];
    const ariaLabel = { "aria-label" : ariaLabelArray.filter(v => !!v).join(", ") };
    return {
      ...ariaLabel,
    }
}